import * as LOGIN from "./login"
import * as LOGOUT from "./logout"
import * as Q1 from "./q1"
import * as Q2 from "./q2"
import * as M1 from "./m1"
import * as M2 from "./m2"
import * as US1 from "./us1"

export const COMMANDS = [LOGIN, LOGOUT, Q1, Q2, M1, M2, US1]
